import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Grid2 as Grid,
  Stack,
  Toolbar,
  Typography,
  TextField,
  Card,
  CardContent,
} from "@mui/material";
import {
  Twitter,
  Facebook,
  LinkedIn,
  Instagram,
  YouTube,
  Menu,
  Celebration,
  Launch,
  PlayCircleOutline,
} from "@mui/icons-material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import CheckIcon from "@mui/icons-material/Check";
import "./App.css";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Rating } from "@mui/material";
import ViewportImg1 from "./Assets/ViewportImg1.png";
import LandingImg2 from "./Assets/LandingImg2.svg";
import DemoGif from "./Assets/DemoGif.gif";
import AIAgentsImg from "./Assets/AIAgentsImg.png";
import CategoryAnalysisImg from "./Assets/CategoryAnalysisImg.png";
import CROAffordableImg from "./Assets/CROAffordableImg.png";
import AgencyFeaturesImg from "./Assets/AgencyFeaturesImg.png";

import PricingPage from "./Pages/PricingPage";

import { CircleDollarSign, Handshake, BriefcaseBusiness } from "lucide-react";

const FeatureCard = ({
  icon: Icon,
  title,
  description,
  primaryColor = "#1d4ed8",
  secondaryColor = "#E8EDFF",
}) => (
  <Card sx={{ borderRadius: "0.5rem", boxShadow: 3 }}>
    <CardContent sx={{ p: 4 }}>
      <Box
        sx={{
          display: "inline-flex",
          p: 2,
          borderRadius: "0.5rem",
          overflow: "hidden",
          boxShadow: 3,
          backgroundColor: secondaryColor,
          mb: 3,
        }}
      >
        <Icon size={20} color={primaryColor} />
      </Box>
      <Box
        sx={{ height: { sm: "100px", md: "180px", lg: "250px", xl: "160px" } }}
      >
        <Typography
          variant="h6"
          fontWeight="550"
          sx={{ color: "#1d4ed8" }}
          gutterBottom
        >
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

function App() {
  const faqs = [
    {
      question: "What is Get Website Report?",
      answer:
        "Get Website Report is an innovative web service that leverages state of the art AI models to analyze and optimize landing pages across five main categories: user interface, user experience, visual design, content, and SEO. We provide actionable insights to enhance the performance and effectiveness of your digital presence.",
    },
    {
      question: "How long does the website audit take?",
      answer:
        "It's almost instant! The website audit will be ready within 3 to 4 minutes.",
    },
    {
      question: "How do I come back to my website audit?",
      answer:
        "You can visit the generated reports page to check your previous audits.",
    },
    {
      question: "What about non-English websites?",
      answer:
        "That’s no problem! Get Website Report's AI is a linguistic ninja.",
    },
    {
      question: "How do i contact you?",
      answer: "Feel free to contact us at support@getwebsite.report",
    },
    {
      question: "Is Get Website Report suitable for any industry?",
      answer:
        "Yes, Get Website Report is designed to be adaptable across diverse industries. Our personalized recommendations take into account the specific needs and characteristics of your industry and target audience.",
    },
  ];

  const [openMenu, setOpenMenu] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const scrollTo = (id) => {
    if (id !== "root") {
      window.history.pushState(null, null, `#${id}`);
    } else {
      window.history.pushState(null, null, "/");
    }
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    setOpenMenu(false);
  };

  useEffect(() => {
    const url = new URL(window.location);
    const id = url.hash.replace("#", "");
    if (id) {
      scrollTo(id);
    }
  }, []);

  return (
    <Container
      id="root"
      sx={{ zoom: { xs: 1, lg: 1.25 } }}
      maxWidth={false}
      disableGutters
    >
      {/* Announcement bar */}

      {/* <Box
        sx={{
          width: "100%",
          bgcolor: "#DDE7FF",
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "relative",
          paddingBottom: "0.2rem",
        }}
      >
        <Typography
          variant="body2"
          fontFamily={"Inter,'Roboto','Helvetica','Arial',sans-serif"}
          fontWeight={400}
          fontSize={"12px"}
          sx={{
            display: "inline-block",
            paddingRight: "2rem",
            animation: "marquee 600s linear infinite",
          }}
        >
          {Array(100)
            .fill("GWR v2.0 is live on Product Hunt! Use PH30 for 30% off.")
            .map((text, index) => (
              <span
                key={index}
                style={{
                  marginRight: "7rem",
                  color: "#3E547C",
                }}
              >
                {text}
              </span>
            ))}
        </Typography>
      </Box>

      <style>
        {`
          @keyframes marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style> */}
      <Container
        maxWidth={false}
        disableGutters
        sx={{ maxWidth: { xs: "100%", md: "90%", lg: "80%" } }}
      >
        {/* Toolbar */}
        <Toolbar
          sx={{
            zIndex: 20,
            paddingY: "0.75rem",
            position: "sticky",
            top: 0,
            display: "flex",
            bgcolor: "white",
            flexDirection: { xs: "column", md: "row" },
            boxShadow: {
              xs: openMenu ? "10px 10px 10px rgba(0,0,0,0.05)" : "none",
              sm: "none",
            },
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Stack
            direction="row"
            sx={{ flexGrow: 1 }}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography
              variant="h5"
              color="#1d4ed8"
              noWrap
              fontSize={"1.5rem"}
              fontWeight={"bold"}
              marginX={"0.75rem"}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                scrollTo("root");
              }}
            >
              GetWebsite.Report
            </Typography>
            <Menu
              size="large"
              sx={{ display: { xs: "block", sm: "none" }, cursor: "pointer" }}
              onClick={() => setOpenMenu(!openMenu)}
            />
          </Stack>

          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={"center"}
            spacing={2}
            sx={{
              mt: { xs: 1, sm: 0 },
              display: { xs: openMenu ? "flex" : "none", sm: "flex" },
              // bgcolor: { xs: "#f8f9fa", sm: "transparent" },
              width: { xs: "100%", sm: "auto" },
              paddingBottom: { xs: 1, sm: 0 },
              borderRadius: { xs: "4px", sm: 0 },
            }}
          >
            <Button
              sx={{ color: "#1d4ed8", textTransform: "none" }}
              onClick={() => {
                scrollTo("sampleReports");
              }}
            >
              Sample Reports
            </Button>
            <Button
              sx={{ color: "#1d4ed8", textTransform: "none" }}
              onClick={() => {
                scrollTo("pricing");
              }}
            >
              Pricing
            </Button>
            <Button
              sx={{ color: "#1d4ed8", textTransform: "none" }}
              onClick={() => {
                scrollTo("features");
              }}
            >
              Features
            </Button>
            <Button
              sx={{ color: "#1d4ed8", textTransform: "none" }}
              onClick={() => {
                window.open("https://getwebsite-report.canny.io/", "_blank");
              }}
            >
              Roadmap
            </Button>
            <Button
              sx={{ color: "#1d4ed8", textTransform: "none" }}
              onClick={() => {
                scrollTo("FAQs");
              }}
            >
              FAQs
            </Button>
            <Button
              variant="contained"
              size="small"
              sx={{
                bgcolor: "#1d4ed8",
                fontWeight: "700",
                fontFamily: "Inter,'Roboto','Helvetica','Arial',sans-serif",
                marginLeft: { xs: 0, sm: "1rem" },
                mt: { xs: 1, sm: 0 },
              }}
              onClick={() =>
                (window.location.href = "https://app.getwebsite.report/login")
              }
            >
              Login
            </Button>
          </Stack>
        </Toolbar>

        {/* 1st Viewport content */}

        <Box
          sx={{
            flexDirection: { xs: "column", md: "row" },
            paddingY: "2rem",
            paddingX: { xs: "1rem", md: "0" },
            display: "flex",
          }}
        >
          <Box sx={{ flex: 6, paddingRight: { md: "2rem" } }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "1rem",
                marginBottom: "2rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: "1rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <a
                  href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                  target="_blank"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=413950&theme=light&t=1742030038655"
                    alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                    style={{ width: "250px", height: "40px" }}
                  />
                </a>
                <a
                  href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                  target="_blank"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/top-post-topic-badge.svg?post_id=413950&theme=light&period=weekly&topic_id=93&t=1742030038655"
                    alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                    style={{ width: "250px", height: "40px" }}
                  />
                </a>
                <a
                  href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                  target="_blank"
                >
                  <img
                    src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=413950&theme=light&period=daily&t=1742030038655"
                    alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                    style={{ width: "250px", height: "40px" }}
                  />
                </a>
              </Box>
              {/* <a
                href="https://www.producthunt.com/posts/getwebsite-report-2-0?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-getwebsite-report-2-0"
                target="_blank"
                style={{ textDecoration: "none", color: "#000" }}
              >
                <Typography
                  variant="body2"
                  textAlign="center"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.3rem",
                    color: "#FF6154",
                    bgcolor: "rgba(255,97,84,0.2)",
                    padding: "0.3rem 1rem",
                    borderRadius: "1rem",
                  }}
                >
                  <Celebration fontSize="small" />
                  GWR v2.0 is live on Product Hunt. Please check it out!
                  <Launch fontSize="1rem" />
                </Typography>
              </a> */}
            </Box>
            <Box
              sx={{
                display: "none",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                gap: "1rem",
                marginBottom: "2rem",
              }}
            >
              <a
                href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=413950&theme=light&t=1737206025090"
                  alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                  style={{ width: "250px", height: "54px" }}
                  width="250"
                  height="54"
                />
              </a>
              <a
                href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/top-post-topic-badge.svg?post_id=413950&theme=light&period=weekly&topic_id=93&t=1737206034722"
                  alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                  style={{ width: "250px", height: "54px" }}
                  width="250"
                  height="54"
                />
              </a>
              <a
                href="https://www.producthunt.com/posts/getwebsite-report?embed=true&utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_souce=badge-getwebsite&#0045;report"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/top-post-topic-badge.svg?post_id=413950&theme=light&period=weekly&topic_id=93&t=1737206034722"
                  alt="GetWebsite&#0046;Report - AI&#0032;powered&#0032;website&#0032;audit&#0032;tool&#0044;&#0032;enhance&#0032;UX&#0032;&#0038;&#0032;boost&#0160;conversion | Product Hunt"
                  style={{ width: "250px", height: "54px" }}
                  width="250"
                  height="54"
                />
              </a>
            </Box>
            <Typography
              variant="h4"
              fontWeight={600}
              mb="1rem"
              textAlign={{ xs: "center", md: "left" }}
            >
              Close more deals for your agency with{" "}
              <span
                style={{
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundImage:
                    "linear-gradient(to right,rgba(29,78,216,1),rgba(219,39,119,1))",
                }}
              >
                AI Website Audits
              </span>
            </Typography>
            <Typography
              variant="body1"
              mb="1.5rem"
              textAlign={{ xs: "center", md: "left" }}
            >
              AI Agents to instantly deliver comprehensive website audits packed
              with tailored insights and proven tactics to boost conversion.
            </Typography>

            {/* bullet points */}
            <Box
              sx={{
                bgcolor: "#DDE7FF",
                padding: "1rem",
                borderRadius: "0.5rem",
                mb: "1.5rem",
              }}
            >
              <Stack spacing={1}>
                {[
                  "Personalized recommendations to improve the conversion rate of your landing page.",
                  "AI-powered actionable suggestions to improve SEO, Usability, Conversion and Messaging.",
                  "Processed 1800+ audits since our launch last year.",
                  "Rated 4.8/5 by 350+ users.",
                ].map((benefit, index) => (
                  <Stack direction="row" alignItems="center" key={index}>
                    <CheckIcon
                      sx={{
                        color: "green",
                        fontSize: "small",
                        marginRight: "5px",
                      }}
                    />
                    <Typography
                      variant="body2"
                      fontSize="0.75rem"
                      fontWeight={550}
                      fontFamily={"Arial, sans-serif"}
                    >
                      {benefit}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </Box>
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#1d4ed8",
                fontWeight: "700",
                textTransform: "none",
                marginX: { xs: "auto", md: 0 },
                display: "block",
              }}
              onClick={() =>
                (window.location.href = "https://app.getwebsite.report/login")
              }
            >
              Run an Audit Now!
            </Button>
            <Typography
              variant="body2"
              mt="1rem"
              textAlign={{ xs: "center", md: "left" }}
              paddingBottom={{ xs: "1rem", md: 0 }}
            >
              Or,{" "}
              <a
                onClick={() => scrollTo("sampleReports")}
                style={{
                  textDecoration: "underline",
                  color: "#1d4ed8",
                  cursor: "pointer",
                }}
              >
                See sample reports
              </a>
            </Typography>
          </Box>
          <Box
            sx={{
              flex: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={ViewportImg1}
              alt="Preview img 1"
              style={{ maxWidth: "100%", borderRadius: "0.5rem" }}
            />
          </Box>
        </Box>

        <Typography
          variant="h4"
          fontWeight={600}
          textAlign="center"
          sx={{ color: "#1d4ed8" }}
        >
          Turn website audits into your agency's unfair advantage
        </Typography>

        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingX: { xs: "1rem", md: "0" },
          }}
        >
          <img src={LandingImg2} alt="customers" style={{ maxWidth: "100%" }} />
        </Box> */}

        {/* 2nd Viewport content */}
        {/* DEMO */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "1rem",
            paddingBottom: "3rem",
            paddingX: { xs: "1rem", md: "0" },
            position: "relative",
            cursor: "pointer",
          }}
          onClick={() => setShowVideo(true)}
        >
          {showVideo ? (
            <iframe
              width="90%"
              height={window.innerWidth > 600 ? "600" : "300"}
              src="https://www.youtube.com/embed/djYttGMjMKw?autoplay=1"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: "0.5rem" }}
            ></iframe>
          ) : (
            <>
              <img
                src={DemoGif}
                alt="Demo"
                style={{
                  width: "100%",
                  borderRadius: "0.5rem",
                }}
              />
              <PlayCircleOutline
                sx={{
                  position: "absolute",
                  color: "grey",
                  opacity: 0.5,
                  fontSize: "10rem",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  transition: "opacity 0.3s",
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            </>
          )}
        </Box>

        <Box
          sx={{
            textAlign: "center",
            paddingY: { xs: "0.5rem", md: "2rem" },
          }}
        >
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: "#1d4ed8",
              fontWeight: "700",
              textTransform: "none",
            }}
            onClick={() =>
              (window.location.href = "https://app.getwebsite.report/login")
            }
          >
            Audit my site!
          </Button>
          <Typography variant="body2" mt="1rem">
            Or,{" "}
            <a
              onClick={() => scrollTo("sampleReports")}
              style={{
                textDecoration: "underline",
                color: "#1d4ed8",
                cursor: "pointer",
              }}
            >
              See sample reports
            </a>
          </Typography>
        </Box>

        {/* Features */}

        <Box
          sx={{
            paddingY: "2rem",
            paddingX: { xs: "0.5rem", md: "0" },
          }}
        >
          <Typography
            variant="h4"
            fontWeight={600}
            textAlign="center"
            mb="1rem"
            color="#1d4ed8"
          >
            Experience the{" "}
            <span
              style={{
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundImage:
                  "linear-gradient(to right,rgba(29,78,216,1),rgba(219,39,119,1))",
              }}
            >
              AI Advantage
            </span>
          </Typography>
          <Container
            maxWidth="lg"
            sx={{
              paddingBottom: { xs: 6, md: 12 },
              paddingTop: { xs: 3, md: 6 },
            }}
          >
            <Grid container spacing={4}>
              {[
                {
                  icon: Handshake,
                  title: "Win More Clients with Value-First Outreach",
                  description:
                    "Instantly generate white-labeled website audits that showcase your expertise. Impress leads with professional reports that pinpoint CRO & SEO opportunities.",
                },
                {
                  icon: BriefcaseBusiness,
                  title: "Close Larger Projects Faster",
                  description:
                    "Use audit insights to recommend high-value services like redesigns & conversion optimization. Position your agency as the go-to expert with data-backed recommendations.",
                },
                {
                  icon: CircleDollarSign,
                  title: "Convert More Leads with Free Website Reports",
                  description:
                    "Use audit reports as lead magnets on your website and ads. Capture high-intent prospects looking for website improvements.",
                },
              ].map((feature, index) => (
                <Grid
                  size={{ xs: 12, md: 6, lg: 4 }}
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "stretch",
                  }}
                >
                  <FeatureCard
                    icon={feature.icon}
                    title={feature.title}
                    description={feature.description}
                    primaryColor={feature.primaryColor}
                    secondaryColor={feature.secondaryColor}
                  />
                </Grid>
              ))}
            </Grid>
          </Container>
          <Typography
            variant="h4"
            fontWeight={600}
            textAlign="center"
            mb="1rem"
            color="#1d4ed8"
            id="features"
          >
            Features
          </Typography>
          {[
            {
              heading: "New in GWR v2: AI Agents for Conversion Optimization",
              bullets: [
                "Observations and recommendation like a seasoned expert.",
                "SEO, Performance and Security Auditing",
                "Identify and critique w.r.t your business type. Ex: e-commerce, SaaS or Lead Gen.",
              ],
              img: AIAgentsImg,
              buttonText: "Try it for yourself",
            },
            {
              heading: "Categories and Section Level insights",
              description:
                "Proven web page optimization methodology that covers copy, design, positioning, social proof, imagery, load speed, and more!",
              bullets: [
                "Category wise guidelines and scoring for a more fine grained audit.",
                "Get specific feedback on YOUR screens using Gen AI",
                "Find quick opportunities to improve your pages",
              ],
              img: CategoryAnalysisImg,
              buttonText: "See it in action",
            },
            {
              heading: "PDF exports with deep customizations",
              description: "Show off your brand on the reports you share.",
              bullets: [
                "Customizable PDF reports with your logo and image.",
                "Editable intro and audit closure write ups.",
                "Schedule an appointment page that nudge the users to book a demo.",
              ],
              img: CROAffordableImg,
              buttonText: "Try it for yourself",
            },
            {
              heading: "Coming Soon: Agency Features",
              bullets: [
                "Editable Audits",
                "Lead Generation Widgets",
                "Multi Page Audits, Competitor Analysis etc.",
              ],
              img: AgencyFeaturesImg,
              buttonText: "See it in action",
            },
          ].map((feature, index) => (
            <>
              {index % 2 === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    paddingY: "1rem",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      flex: 4,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: { xs: "center", md: "flex-start" },
                      justifyContent: "center",
                      paddingLeft: { md: "7rem" },
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight={600}
                      mb="1rem"
                      color="#1d4ed8"
                      textAlign={{ xs: "center", md: "left" }}
                    >
                      {feature.heading}
                    </Typography>
                    {feature.description && (
                      <Typography
                        variant="body2"
                        mb="1rem"
                        textAlign={{
                          xs: "center",
                          md: "left",
                          color: "#3E547C",
                        }}
                      >
                        {feature.description}
                      </Typography>
                    )}
                    <ul>
                      {feature.bullets.map((bullet, idx) => (
                        <li
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            marginBottom: "0.5rem",
                          }}
                        >
                          <CheckIcon
                            sx={{
                              color: "green",
                              fontSize: "small",
                              marginRight: "5px",
                            }}
                          />
                          <Typography variant="body2">{bullet}</Typography>
                        </li>
                      ))}
                    </ul>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#1d4ed8",
                        mt: "1rem",
                        textTransform: "none",
                      }}
                      onClick={() =>
                        (window.location.href =
                          "https://app.getwebsite.report/login")
                      }
                    >
                      {feature.buttonText}
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      flex: 6,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={feature.img}
                      alt={`Feature ${index + 1}`}
                      style={{ maxWidth: "100%", borderRadius: "0.5rem" }}
                    />
                  </Box>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    paddingY: "2rem",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      flex: 6,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={feature.img}
                      alt={`Feature ${index + 1}`}
                      style={{ maxWidth: "100%", borderRadius: "0.5rem" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      flex: 4,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: { xs: "center", md: "flex-start" },
                      justifyContent: "center",
                      paddingRight: { md: "2rem" },
                      paddingLeft: { md: "7rem" },
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight={600}
                      mb="1rem"
                      color="#1d4ed8"
                      textAlign={{ xs: "center", md: "left" }}
                    >
                      {feature.heading}
                    </Typography>
                    {feature.description && (
                      <Typography
                        variant="body2"
                        mb="1rem"
                        textAlign={{
                          xs: "center",
                          md: "left",
                          color: "#3E547C",
                        }}
                      >
                        {feature.description}
                      </Typography>
                    )}
                    <ul>
                      {feature.bullets.map((bullet, idx) => (
                        <li
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "baseline",
                            marginBottom: "0.5rem",
                          }}
                        >
                          <CheckIcon
                            sx={{
                              color: "green",
                              fontSize: "small",
                              marginRight: "5px",
                            }}
                          />
                          <Typography variant="body2">{bullet}</Typography>
                        </li>
                      ))}
                    </ul>
                    <Button
                      variant="contained"
                      sx={{
                        bgcolor: "#1d4ed8",
                        mt: "1rem",
                        textTransform: "none",
                      }}
                      onClick={() =>
                        (window.location.href =
                          "https://app.getwebsite.report/login")
                      }
                    >
                      {feature.buttonText}
                    </Button>
                  </Box>
                </Box>
              )}
              <Box
                sx={{
                  borderBottom: "1px solid #BDBDBD",
                  width: "60%",
                  margin: "0 auto",
                }}
              />
            </>
          ))}
        </Box>

        {/* Sample Reports */}

        <Box
          id="sampleReports"
          sx={{
            paddingTop: { xs: "1rem", md: "2rem" },
            paddingX: { xs: "0.5rem", md: "0" },
          }}
        >
          <Typography
            variant="h4"
            fontWeight={600}
            textAlign="center"
            mb="2rem"
            color="#1d4ed8"
          >
            Sample Reports
          </Typography>
          <Typography variant="body1" textAlign="center" mb="2rem">
            Check out some of our sample reports to see the detailed insights
            and recommendations we provide.
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {[
              {
                img: "https://gwt-images.s3.amazonaws.com/gwr-v2-images/www_beautyenergyexchange_0_2025-01-19_1737275041625.jpg",
                website: "Beautyenergyechange.com",
                link: "https://app.getwebsite.report/audit/report/abced1e2-7a18-4df7-9677-c37473cd1153",
              },
              {
                img: "https://gwt-images.s3.amazonaws.com/gwr-v2-images/crosswyndeapts_0_2025-01-19_1737276609956.jpg",
                website: "Crosswyndeapts.com",
                link: "https://app.getwebsite.report/audit/report/4c93f90b-efa5-46fe-afb7-b5e27a251afe",
              },
              {
                img: "https://gwt-images.s3.amazonaws.com/gwr-v2-images/beavercrafttools_0_2025-01-19_1737276948240.jpg",
                website: "beavercrafttools.com",
                link: "https://app.getwebsite.report/audit/report/a34fc0cb-6651-4da7-acbc-3f17e27334c8",
              },
            ].map((report, index) => (
              <Grid size={{ xs: 11, sm: 6, lg: 4 }} key={index}>
                <Box
                  sx={{
                    borderRadius: "0.5rem",
                    overflow: "hidden",
                    boxShadow: 3,
                    height: "100%",
                    transition: "transform 0.2s",
                    ":hover": { transform: "scale(1.05)", cursor: "pointer" },
                  }}
                  onClick={() => window.open(report.link, "_blank")}
                >
                  <Box
                    component="img"
                    src={report.img}
                    alt={report.website}
                    sx={{ width: "100%", height: "70%", objectFit: "fill" }}
                  />
                  <Box
                    sx={{
                      bgcolor: "white",
                      padding: "1.5rem 0.5rem 0 0.5rem",
                      textAlign: "center",
                      height: "30%",
                    }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      color="#1d4ed8"
                    >
                      {report.website}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ textAlign: "center", paddingY: "2rem" }}>
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#1d4ed8",
                fontWeight: "700",
                textTransform: "none",
              }}
              onClick={() =>
                (window.location.href = "https://app.getwebsite.report/login")
              }
            >
              Start your Audit
            </Button>
          </Box>
        </Box>

        {/* Pricing Page */}

        <Box id="pricing">
          <PricingPage />
        </Box>

        {/* FAQS */}

        <Box
          id="FAQs"
          sx={{
            paddingTop: { xs: "1rem", md: "2rem" },
            paddingX: { xs: "0.5rem", md: "0" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            fontWeight={600}
            textAlign="center"
            mb={{ xs: "1rem", md: "2rem" }}
            color="#1d4ed8"
          >
            FAQs
          </Typography>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                marginBottom: { xs: "0.5rem", md: "1rem" },
                borderRadius: "4px",
                overflow: "hidden",
                border: "1px solid #e3e8ef",
                boxShadow: 0,
                width: { xs: "90%", md: "80%", lg: "60%" },
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" fontFamily="Helvetica">
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="subtitle2" fontFamily="Helvetica">
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}

          <Typography variant="body2" textAlign="center" mt="2rem">
            still have questions? Email us at <u>support@getwebsite.report</u>
          </Typography>
        </Box>

        {/* Reviews */}

        <Box
          sx={{
            paddingY: { xs: "2rem", md: "2rem" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            fontWeight={600}
            textAlign="center"
            mb="0.5rem"
            color="#1d4ed8"
          >
            Still not convinced?
          </Typography>
          <Typography
            variant="body1"
            textAlign="center"
            mb="2rem"
            color="#6b6b6b"
          >
            It worked for all of them
          </Typography>
          <Grid
            container
            rowSpacing={4}
            columnSpacing={12}
            justifyContent="center"
            alignItems="center"
            width={"75%"}
          >
            {[
              {
                img: "https://gwt-images.s3.us-west-2.amazonaws.com/gwr-v3-images/user/jim_mosier.png",
                name: "Jim Mosier",
                position: "Founder, MosierData",
                rating: 5,
                review:
                  "Thank you for your hands-on support in quickly setting up GetWebsite Reports on my subdomain. The team was incredibly thorough and professional throughout the process.",
              },
              {
                img: "https://gwt-images.s3.us-west-2.amazonaws.com/gwr-v3-images/user/yash_patel.png",
                name: "Yash Patel",
                position: "Founder, MilkTub",
                rating: 5,
                review:
                  "I have worked with multiple teams so far. I just wanted to say, your team is kind of awesome!",
              },
              {
                img: "https://gwt-images.s3.us-west-2.amazonaws.com/gwr-v3-images/user/shahz.png",
                name: "Shahz S",
                position: "CEO, Sirge",
                rating: 5,
                review:
                  "The GetWebsite Report team experimented with various techniques to generate reports tailored to our specific needs and trained our in-house team to become experts in AI Website Auditing. I highly recommend them.",
              },
              {
                img: "https://gwt-images.s3.us-west-2.amazonaws.com/gwr-v3-images/user/joe_harris.png",
                name: "Joe Harris",
                position: "Founder, ShiftScale Digital",
                rating: 5,
                review:
                  "I've been working with them for several months now, and I'm in awe of the team's ability to take feedback and quickly iterate. Their tools have saved my team and me a ton of time and made sales calls far less daunting.",
              },
            ].map((review, index) => (
              <Grid size={{ xs: 12, sm: 6 }} key={index}>
                <Box
                  sx={{
                    borderRadius: "0.5rem",
                    overflow: "hidden",
                    boxShadow: 3,
                    height: "100%",
                    bgcolor: "#F8F7F6",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      padding: "1rem",
                      flexGrow: 1,
                    }}
                  >
                    <Typography
                      variant="body2"
                      color="#6b6b6b"
                      sx={{
                        display: "-webkit-box",
                        overflow: "hidden",
                        // WebkitBoxOrient: "vertical",
                        // WebkitLineClamp: 5,
                      }}
                      minHeight={"5rem"}
                    >
                      <FormatQuoteIcon
                        sx={{ transform: "rotate(180deg)", fontSize: "1rem" }}
                      />
                      {review.review}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      padding: "1rem",
                    }}
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid size={{ xs: 12 }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent={{ xs: "center", sm: "flex-start" }}
                        >
                          <img
                            src={review.img}
                            alt={review.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                          <Stack
                            direction="column"
                            sx={{ marginLeft: "0.5rem" }}
                          >
                            <Typography variant="subtitle2" fontWeight={600}>
                              {review.name}
                            </Typography>
                            <Typography variant="caption" color="#6b6b6b">
                              {review.position}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      {/* <Grid size={{ xs: 12, lg: 6 }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Rating
                            name="half-rating-read"
                            defaultValue={review.rating}
                            precision={0.1}
                            readOnly
                          />
                        </Stack>
                      </Grid> */}
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>

      <Box
        sx={{
          textAlign: "center",
          paddingY: "2rem",
          bgcolor: "#1d4ed8",
          marginTop: "2rem",
        }}
      >
        <Typography variant="h4" fontWeight={600} mb="0.2rem" color="white">
          Stop loosing potential customers
        </Typography>
        <Typography
          variant="body2"
          mb="1rem"
          color="white"
          paddingX={{ xs: "1rem", sm: 0 }}
        >
          Sign up to see a sneak peak into the power of our AI-driven analysis
        </Typography>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          maxWidth={{ xs: "300px", sm: "100%" }}
          margin={{ xs: "0 auto", sm: 0 }}
        >
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: "orange",
              fontWeight: "700",
              textTransform: "none",
            }}
            onClick={() =>
              (window.location.href = "https://app.getwebsite.report/login")
            }
          >
            Get started
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{
              bgcolor: "white",
              fontWeight: "700",
              textTransform: "none",
            }}
            onClick={() => scrollTo("sampleReports")}
          >
            Sample Reports
          </Button>
        </Stack>
      </Box>

      {/* Footer */}
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          maxWidth: `80%`,
          marginTop: "3rem",
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          textAlign={{ xs: "center", sm: "left" }}
          marginBlockEnd={"3rem"}
        >
          <Grid size={{ xs: 12, sm: 3, md: 2 }}>
            <Stack direction="column">
              <Typography variant="caption" color="grey">
                Platform
              </Typography>
              {[
                { text: "Home", link: "#" },
                { text: "Login", link: "#" },
                { text: "Pricing", link: "#pricing" },
                { text: "Get in touch", link: "#FAQs" },
              ].map((link) => {
                return (
                  <a href={link.link}>
                    <Typography variant="caption" marginY={"0.3rem"}>
                      {link.text}
                    </Typography>
                  </a>
                );
              })}
            </Stack>
            <Box
              sx={{
                borderBottom: "1px solid #e5e7eb",
                width: "60%",
                marginX: "auto",
                marginTop: "1rem",
                display: { xs: "block", sm: "none" },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3, md: 2 }}>
            <Stack direction="column">
              <Typography variant="caption" color="grey">
                Company
              </Typography>
              {[
                { text: "About", link: "#" },
                { text: "Terms", link: "#" },
                { text: "Privacy Policy", link: "#" },
                { text: "Careers", link: "#" },
              ].map((link) => {
                return (
                  <a href={link.link}>
                    <Typography variant="caption" marginY={"0.3rem"}>
                      {link.text}
                    </Typography>
                  </a>
                );
              })}
            </Stack>
            <Box
              sx={{
                borderBottom: "1px solid #e5e7eb",
                width: "60%",
                marginX: "auto",
                marginTop: "1rem",
                display: { xs: "block", sm: "none" },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3, md: 2 }}>
            <Stack direction="column">
              <Typography variant="caption" color="grey">
                Resources
              </Typography>
              {[
                {
                  text: "Affliate",
                  link: "https://billing.getwebsite.report/affiliates",
                },
                { text: "White Label", link: "#" },
                { text: "Feedback", link: "#FAQs" },
              ].map((link) => {
                return (
                  <a href={link.link}>
                    <Typography variant="caption" marginY={"0.3rem"}>
                      {link.text}
                    </Typography>
                  </a>
                );
              })}
            </Stack>
            <Box
              sx={{
                borderBottom: "1px solid #e5e7eb",
                width: "60%",
                marginX: "auto",
                marginTop: "1rem",
                display: { xs: "block", sm: "none" },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack direction="column">
              <Typography variant="caption" color="grey">
                Newsletter
              </Typography>
              <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems="center"
                spacing={2}
                marginY={"0.5rem"}
              >
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Your email"
                  fullWidth
                />
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    bgcolor: "#1d4ed8",
                    textTransform: "none",
                    paddingX: "1rem",
                    maxWidth: "7rem",
                  }}
                >
                  Subscribe
                </Button>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingY: "1rem",
            borderTop: "1px solid #e0e0e0",
            gap: "1rem",
          }}
        >
          <Typography variant="body2" color="textSecondary" textAlign="center">
            © 2025 GetWebsite.Report. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2}>
            <a href="https://facebook.com" target="_blank" rel="noreferrer">
              <Facebook sx={{ color: "#1d4ed8" }} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer">
              <Twitter sx={{ color: "#1d4ed8" }} />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer">
              <LinkedIn sx={{ color: "#1d4ed8" }} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <Instagram sx={{ color: "#1d4ed8" }} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer">
              <YouTube sx={{ color: "#1d4ed8" }} />
            </a>
          </Stack>
        </Stack>
      </Container>
    </Container>
  );
}

export default App;
